/** Minimum encoded MP3 size (bytes) before we treat a clip as a real recording. */
export const SPEAKING_MIN_BLOB_BYTES = 8192;

/**
 * Server should reject speaking payloads shorter than this (data URL character count).
 * Keep in sync with server/controllers/gradingController.js MIN_SPEAKING_ANSWER_LENGTH.
 */
export const SPEAKING_MIN_DATA_URL_CHARS = 10000;

/**
 * @param {Blob} blob
 * @returns {Promise<{ ok: true } | { ok: false, message: string }>}
 */
export async function validateSpeakingRecordingBlob(blob) {
  if (!(blob instanceof Blob) || blob.size < SPEAKING_MIN_BLOB_BYTES) {
    return {
      ok: false,
      message:
        "The recording is too small or empty. Check that your microphone is working and allowed in the browser, then try again.",
    };
  }

  const head = new Uint8Array(await blob.slice(0, 4).arrayBuffer());
  const hasId3Tag = head[0] === 0x49 && head[1] === 0x44 && head[2] === 0x33;
  const hasMpegSync = head[0] === 0xff && (head[1] & 0xe0) === 0xe0;
  if (!hasId3Tag && !hasMpegSync) {
    return {
      ok: false,
      message:
        "The recording could not be recognized as valid audio. Check your microphone and try again.",
    };
  }

  return { ok: true };
}
